<div class="dialog-field-group">
    @if( showLabel ) {
        <mat-label class="mat-form-field-label">
                {{ label }}
                @if( required ) {
                    <span class="req">*</span>
                }
        </mat-label>
    }
    <mat-form-field appearance="outline">
        <input matInput [formControl]="fileFormControl" (click)="fileSelect.click()" [readonly]="true" placeholder="Select a file">
        <mat-icon matSuffix class="action-icon" matTooltip="Clear selection" (click)="onClearSelection()">cancel</mat-icon>
        @if (fileFormControl.hasError('required') && (fileFormControl.touched || fileFormControl.dirty)) {
            <mat-error>File is required</mat-error>
        }
        @if (fileFormControl.hasError('pattern') && (fileFormControl.touched || fileFormControl.dirty)) {
            <mat-error>Filename has invalid characters</mat-error>
        }
    </mat-form-field>
</div>

<input type="file" id="fileSelect" name="fileSelect" #fileSelect [multiple]="multiple" [accept]="accept" style="display:none;" (change)="onSelectFile()"/>